import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";
import {DceAjax} from "dce-ajax";
import RefreshableInterface from "./utils/RefreshableInterface";
import OpenDialog from "./modal/OpenDialog";
import {AjaxBlock} from "../index";
import {DceEngine} from "../../../dce-engine";

interface AjaxTabsProps {
    target: string;
}

@Dce("AjaxTabs")
export default class AjaxTabs extends DceComponent<AjaxTabsProps> {

    private logger = Logger.of("AjaxTabs");
    private target: JQuery<HTMLElement>;

    private tabs: JQuery<HTMLElement>;

    protected targetAjaxBlock: AjaxBlock;

    constructor(elem: DceHTMLElement, props: AjaxTabsProps) {
        super(elem, props);
        this.logger.debug("Init AjaxTabs");

        this.setupTarget();

        this.tabs = $(this.elem);

        this.tabs.on('click', 'a', e => {
            e.preventDefault();

            let target = e.target as HTMLElement;

            let href = target.getAttribute('href');

            this.targetAjaxBlock.loadUrl(href, () => {
                this.tabs.find('.tab')
                    .removeClass('active');

                if(target.classList.contains('tab')){
                    target.classList.add('active');
                }else{
                    $(target).closest('.tab').addClass('active');
                }
            });

            return false;
        })
    }

    protected setupTarget(){
        if(this.props.target == '>'){
            this.target = $(this.elem).next();
        }else{
            this.target = $(this.props.target);
        }

        console.log("-!!!!!!!!!!!!!!!!!!!!!!!!!!!-------------------");

        this.targetAjaxBlock = DceEngine.getInstance().addComponentsOnElement(
            this.target[0] as DceHTMLElement,
            "AjaxBlock",
            {
                replace: false,
                loadOnStart: false
            }
        );

        console.log("AJAXBlock: " + this.targetAjaxBlock);

        console.log("/// -!!!!!!!!!!!!!!!!!!!!!!!!!!!-------------------");


    }

    defaultProps(): Partial<AjaxTabsProps> {
        return {
            target: '>'
        }
    }
}
